export default {
  backend: 'https://api.coinbase.com/v2/',
  email: 'support@bistook.com',
  phone: '+963932415979',
  fb: 'https://www.facebook.com/BitSook-100771925198232',
  insta: ' https://www.instagram.com/bitsook/',
  linkedin: 'https://www.linkedin.com/company/69682020/admin/',
};
